import React from 'react';
import { Row, Col, Label, Input } from 'reactstrap';

const PersonalInfo = ({ onNext }) => {
  return (
    <div>
      <h5 className="mb-1">Billing Information</h5>
      <p className="text-muted mb-4">Please fill all information below</p>
      <Row>
        <Col sm={6}>
          <div className="mb-3">
            <Label htmlFor="billinginfo-firstName" className="form-label">First Name</Label>
            <Input type="text" className="form-control" id="billinginfo-firstName" placeholder="Enter first name" />
          </div>
        </Col>
        <Col sm={6}>
          <div className="mb-3">
            <Label htmlFor="billinginfo-lastName" className="form-label">Last Name</Label>
            <Input type="text" className="form-control" id="billinginfo-lastName" placeholder="Enter last name" />
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <div className="mb-3">
            <Label htmlFor="billinginfo-email" className="form-label">Email <span className="text-muted">(Optional)</span></Label>
            <Input type="email" className="form-control" id="billinginfo-email" placeholder="Enter email" />
          </div>
        </Col>
        <Col sm={6}>
          <div className="mb-3">
            <Label htmlFor="billinginfo-phone" className="form-label">Phone</Label>
            <Input type="text" className="form-control" id="billinginfo-phone" placeholder="Enter phone no." />
          </div>
        </Col>
      </Row>
      <div className="mb-3">
        <Label htmlFor="billinginfo-address" className="form-label">Address</Label>
        <textarea className="form-control" id="billinginfo-address" placeholder="Enter address" rows="3"></textarea>
      </div>
      <div className="d-flex align-items-start mt-3">
        <button type="button" className="btn btn-primary btn-label right ms-auto nexttab" onClick={onNext}>
          Proceed to Payment
        </button>
      </div>
    </div>
  );
};

export default PersonalInfo;